// services/budgetApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import {
  ApiReportsResponse,
  GetCommissionStatisticsResponse,
  CommissionData,
} from '../../../types/reports';
import { baseQueryWithReauth } from '../baseQuery';

export const commissionReportsService = createApi({
  reducerPath: 'commissionReportsService',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getCommissionStatistics: builder.query<
      GetCommissionStatisticsResponse,
      void
    >({
      query: () => ({
        url: `/payments-service/v1/total-revenue/stats`,
      }),
    }),
    getCommission: builder.query<ApiReportsResponse<CommissionData>, string>({
      query: (params) => ({
        url: `/payments-service/v1/commission?${params}`,
      }),
    }),
    exportCommission: builder.query<any, { params: string; format: string }>({
      query: ({ params, format }) => ({
        url: `/payments-service/v1/commission/export-${format}?${params}`,
        responseHandler: async (response) => await response.blob(),
      }),
    }),
  }),
});

export const {
  useGetCommissionStatisticsQuery,
  useGetCommissionQuery,
  useLazyExportCommissionQuery,
} = commissionReportsService;
